import { AppSessionContext } from '../SessionContext/AppSessionContext';

const ApiSiteOptions = AppSessionContext.getInstance().AppConfig.siteOptions;

export const HttpRequestServiceSettings = {
  PartnerApiEndpoint: ApiSiteOptions.partnerApiEndpoint,
  PartnerSupportServiceEndpoint: ApiSiteOptions.supportServicesEndpoint,
  ServiceRequestEndpoint: ApiSiteOptions.supportServicesEndpoint + '/v1/servicerequests',
  PartnerApiTrafficManagerEndpoint: ApiSiteOptions.partnerApiTrafficManagerEndpoint,
  PartnerSupportCDNEnpoint: ApiSiteOptions.supportStoreCDNEndpoint,
  InternalSupportRequest: ApiSiteOptions.supportServicesEndpoint + '/internal',
  InternalSupportRequestTrafficManager: ApiSiteOptions.partnerApiAdminTrafficManagerEndpoint + '/internal',
  PartnerSupportUIEndpoint: ApiSiteOptions.partnerSupportUIEndpoint,
  PpeMetadataEndpoint: ApiSiteOptions.ppePartnerApiAdminTrafficManagerEndpoint + '/internal',
  SupportRequestTrafficManager: ApiSiteOptions.partnerApiAdminTrafficManagerEndpoint,
  CustomerServiceAdminEndpoint: ApiSiteOptions.customerServiceAdminEndpoint,
  PartnerServiceCustomerEndpoint: ApiSiteOptions.supportServicesEndpoint + '/v1/customers',
};
